import type { FaireProductEntity } from "../../entity_types/product";

export const toysmith_16: FaireProductEntity = {
  token: "toysmith-16",
  type: "product",
  name: "Space Cat Inflatable Beach Ball",
  brandName: "Toysmith",
  imageUrl:
    "https://cdn.faire.com/fastly/9e51f7e195b3966310a9b8a9c5ee060906d4a07a3de0df61ebbfd382e801b120.jpeg?bg-color=FFFFFF&dpr=1&fit=crop&format=jpg&height=720&precrop=504,504,x105,y99,safe&width=720",
  priceDollars: 8,
  msrpDollars: 16,
  freeShipping: false,
  isBestseller: false,
  description: "",
  categoryTokens: ["cat_kids-toys"],
  tags: [],
  inStock: true,
  meta: {
    source: "mock",
    importedAt: "2026-03-24T00:00:00.000Z",
    importedBy: "legacy-products-migration",
  },
};
